import React from 'react';
import { FileModelPlus } from 'services/EpdClient';
import FileService from 'services/FileService';
import styled from 'styled-components';

interface ImageViewProps {
  images?: FileModelPlus[];
}

export const PDFImagesViewFullWidth: React.FunctionComponent<ImageViewProps> = ({ images }) => {
  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const img = e.currentTarget;
    const isLandscape = img.naturalWidth >= img.naturalHeight;

    img.style.width = isLandscape ? '100%' : 'auto';
    img.style.height = isLandscape ? 'auto' : '100vh';
  };

  return (
    <div>
      {images &&
        images.map((img) => (
          <ImageBox key={img.id}>
            <img src={FileService.getImageUrl(img.id)} onLoad={handleImageLoad} />
          </ImageBox>
        ))}
    </div>
  );
};

const ImageBox = styled.div`
  min-width: 250px;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.colors.primaryWhite};
  margin-bottom: 30px;

  img {
    max-width: 100%;
    max-height: 600pt;
  }
`;
